import { loadView } from '@/router'

export default [
  {
    path: 'todo',
    name: 'sales-todo',
    component: loadView('Application/Sales/ToDo')
  }
]
